import { Styles } from "jspdf-autotable";

export const getFonts = () => {
  const normalFontSize = 10;
  const bigFontSize = 12;

  const normalFontStyles: Partial<Styles> = {
    fontSize: normalFontSize,
    font: "helvetica",
    fontStyle: "bold"
  };
  const bigFontStyles: Partial<Styles> = {
    fontSize: bigFontSize,
    font: "helvetica",
    fontStyle: "bold"
  };

  return {
    normalFontSize,
    normalFontStyles,
    bigFontSize,
    bigFontStyles
  };
};
